export default "__VITE_ASSET__B_sWCvY9__"